export const getTemplateDisplayName = (name?: string | null): string => {
  return (name ?? '').replace(/_\d+$/, '').trim()
}
